import React from 'react'

// Factory for creating different types of StatusIcon components
const createStatusIcon = (id, classes) => () => (
    <span className={`${id} fa-stack fa-2x`}>
        <i className="fa fa-circle fa-stack-2x" style={{ color: '#0c3c65' }} />
        <i className={`fa fa-stack-1x ${classes} fa-inverse`} />
    </span>
)

export default {
    Upload: createStatusIcon('status__upload', 'fa-upload'),
    Success: createStatusIcon('status__success', 'fa-check'),
    Error: createStatusIcon('status__error', 'fa-times'),
    Spinner: createStatusIcon('status__spinner', 'fa-spinner fa-spin'),
    Plus: createStatusIcon('status__plus', 'fa-plus')
}
